import {IconButton, IconButtonProps} from '@mui/material';
import IconDelete from '../../asset/icons/icon_delete.svg';

const IconDeleteButton: React.FC<IconButtonProps> = ({
  size = 'small',
  ...buttonProps
}) => {
  return (
    <IconButton title='Delete' color='error' size={size} {...buttonProps}>
      {IconDelete && <img src={IconDelete} alt='' />}
    </IconButton>
  );
};

export default IconDeleteButton;
